module.exports = __webpack_public_path__ + "static/media/body_tu3.f7ce2fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/body_tu3.png
// module id = 1585
// module chunks = 10